import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'

const NotFound = () => {

  const auth = useSelector((state:any)=> state.userInfo.data)
  const nav = useNavigate();

  console.log('notfound ' , auth)

  useEffect(()=>{
    if (!auth.login){
      nav("/");
    }
  })
  
  return (
    <div>404 not found</div>
  )
}

export default NotFound